module.exports = __webpack_public_path__ + "static/media/ve.static.93a263dc.svg";